// extracted by mini-css-extract-plugin
export default {"underlay":"GCCSS","container":"Ujjaw","grey":"HuPMw","iconX":"mCoIB","closeButtonX":"KS2Hs","asButton":"_1Cpen"};